(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-product-product-domain.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-product-product-domain.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-query-product-query-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-product-query-product-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-query-product-query-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-f2-product-query-product-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-product-product-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-query-product-query-domain'. Its dependency 'boislocal-platform-platform-s2-product-product-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-product-product-domain' is loaded prior to 'boislocal-platform-platform-f2-product-query-product-query-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-query-product-query-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-f2-product-query-product-query-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-query-product-query-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-f2-product-query-product-query-domain'.");
    }
    root['boislocal-platform-platform-f2-product-query-product-query-domain'] = factory(typeof this['boislocal-platform-platform-f2-product-query-product-query-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-product-query-product-query-domain'], this['kotlin-kotlin-stdlib'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-product-product-domain'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_product_domain, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var S2_getInstance = kotlin_org_boislocal_product_domain.$_$.a;
  var ProductUpdateCommand = kotlin_org_boislocal_product_domain.$_$.j;
  var getKClass = kotlin_kotlin.$_$.f;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var ProductDeleteCommand = kotlin_org_boislocal_product_domain.$_$.c;
  var ProductFinishCommand = kotlin_org_boislocal_product_domain.$_$.d;
  var ProductUnlockCommand = kotlin_org_boislocal_product_domain.$_$.i;
  var ProductInitLinkedCommand = kotlin_org_boislocal_product_domain.$_$.e;
  var ProductTransformationActorDefineCommand = kotlin_org_boislocal_product_domain.$_$.g;
  var ProductTransformationDateChangeCommand = kotlin_org_boislocal_product_domain.$_$.h;
  var ProductRenameCommand = kotlin_org_boislocal_product_domain.$_$.f;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var VOID = kotlin_kotlin.$_$.g;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ProductDTO, 'ProductDTO', interfaceMeta);
  setMetadataFor(ProductPolicies, 'ProductPolicies', objectMeta);
  setMetadataFor(ProductGetQueryDTO, 'ProductGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(ProductGetResponseDTO, 'ProductGetResponseDTO', interfaceMeta);
  setMetadataFor(ProductPageQueryDTO, 'ProductPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(ProductPageResponseDTO, 'ProductPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function ProductDTO() {
  }
  function ProductPolicies() {
  }
  protoOf(ProductPolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(ProductPolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(ProductPolicies).canRefs = function (authedUser) {
    return true;
  };
  protoOf(ProductPolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(ProductPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canFinish = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductFinishCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canFinish.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canUnlock = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductUnlockCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canUnlock.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canInitLinked = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductInitLinkedCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canInitLinked.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canTransformationActorDefine = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductTransformationActorDefineCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canTransformationActorDefine.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canChangeDate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductTransformationDateChangeCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canChangeDate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProductPolicies).canRename = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2q_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(ProductRenameCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.ProductPolicies.canRename.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var ProductPolicies_instance;
  function ProductPolicies_getInstance() {
    return ProductPolicies_instance;
  }
  function ProductGetQueryDTO() {
  }
  function ProductGetResponseDTO() {
  }
  function ProductPageQueryDTO() {
  }
  function ProductPageResponseDTO() {
  }
  //region block: init
  ProductPolicies_instance = new ProductPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$query = $org$boislocal$platform$f2$product.query || ($org$boislocal$platform$f2$product.query = {});
    var $org$boislocal$platform$f2$product$query$domain = $org$boislocal$platform$f2$product$query.domain || ($org$boislocal$platform$f2$product$query.domain = {});
    var $org$boislocal$platform$f2$product$query$domain$model = $org$boislocal$platform$f2$product$query$domain.model || ($org$boislocal$platform$f2$product$query$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$policy = $org$boislocal$platform$f2$realization$query$domain.policy || ($org$boislocal$platform$f2$realization$query$domain.policy = {});
    defineProp($org$boislocal$platform$f2$realization$query$domain$policy, 'ProductPolicies', ProductPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$query = $org$boislocal$platform$f2$product.query || ($org$boislocal$platform$f2$product.query = {});
    var $org$boislocal$platform$f2$product$query$domain = $org$boislocal$platform$f2$product$query.domain || ($org$boislocal$platform$f2$product$query.domain = {});
    var $org$boislocal$platform$f2$product$query$domain$query = $org$boislocal$platform$f2$product$query$domain.query || ($org$boislocal$platform$f2$product$query$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$query = $org$boislocal$platform$f2$product.query || ($org$boislocal$platform$f2$product.query = {});
    var $org$boislocal$platform$f2$product$query$domain = $org$boislocal$platform$f2$product$query.domain || ($org$boislocal$platform$f2$product$query.domain = {});
    var $org$boislocal$platform$f2$product$query$domain$query = $org$boislocal$platform$f2$product$query$domain.query || ($org$boislocal$platform$f2$product$query$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-product-query-product-query-domain.js.map
